// eslint-disable-next-line no-restricted-imports -- factory called at render time by useTranslation-aware consumers
import { t } from 'i18n/utils'

export const fieldTypesWithDropdownEntries = ['dropdown', 'multi_select']
export const fieldTypesWithReportBehavior = ['currency', 'forecast', 'numeric']
export const getFieldTypes = () => ({
  boolean: {
    definition: t('admin.customFields.fieldTypes.booleanDef'),
    name: t('admin.customFields.fieldTypes.booleanName')
  },
  calculated: {
    definition: t('admin.customFields.fieldTypes.calculatedDef'),
    name: t('admin.customFields.fieldTypes.calculatedName')
  },
  currency: {
    definition: t('admin.customFields.fieldTypes.currencyDef'),
    name: t('admin.customFields.fieldTypes.currencyName')
  },
  date: {
    definition: t('admin.customFields.fieldTypes.dateDef'),
    name: t('admin.customFields.fieldTypes.dateName')
  },
  dropdown: {
    definition: t('admin.customFields.fieldTypes.dropdownDef'),
    name: t('admin.customFields.fieldTypes.dropdownName')
  },
  forecast: {
    definition: t('admin.customFields.fieldTypes.forecastDef'),
    name: t('admin.customFields.fieldTypes.forecastName')
  },
  multi_association: {
    definition: t('admin.customFields.fieldTypes.multiAssocDef'),
    name: t('admin.customFields.fieldTypes.multiAssocName')
  },
  numeric: {
    definition: t('admin.customFields.fieldTypes.numericDef'),
    name: t('admin.customFields.fieldTypes.numericName')
  },
  multi_select: {
    definition: t('admin.customFields.fieldTypes.multiSelectDef'),
    name: t('admin.customFields.fieldTypes.multiSelectName')
  },
  single_association: {
    definition: t('admin.customFields.fieldTypes.singleAssocDef'),
    name: t('admin.customFields.fieldTypes.singleAssocName')
  },
  text: {
    definition: t('admin.customFields.fieldTypes.textDef'),
    name: t('admin.customFields.fieldTypes.textName')
  }
})
export const itemTypes = {
  DROPDOWN_ENTRY: 'DROPDOWN_ENTRY',
  LABEL: 'LABEL'
}

export const FETCH_CUSTOM_FIELDS = 'FETCH_CUSTOM_FIELDS'
export const RECEIVE_CUSTOM_FIELDS = 'RECEIVE_CUSTOM_FIELDS'

export const DELETE_CUSTOM_FIELD_GROUP = 'DELETE_CUSTOM_FIELD_GROUP'
export const DELETE_CUSTOM_FIELD_GROUP_FAILURE = 'DELETE_CUSTOM_FIELD_GROUP_FAILURE'
export const DELETE_CUSTOM_FIELD_GROUP_SUCCESS = 'DELETE_CUSTOM_FIELD_GROUP_SUCCESS'

export const DELETE_CUSTOM_FIELD_LABEL = 'DELETE_CUSTOM_FIELD_LABEL'
export const DELETE_CUSTOM_FIELD_LABEL_FAILURE = 'DELETE_CUSTOM_FIELD_LABEL_FAILURE'
export const DELETE_CUSTOM_FIELD_LABEL_SUCCESS = 'DELETE_CUSTOM_FIELD_LABEL_SUCCESS'

export const EDIT_CUSTOM_FIELD_GROUP_FORM_FAILURE = 'EDIT_CUSTOM_FIELD_GROUP_FORM_FAILURE'
export const EDIT_CUSTOM_FIELD_GROUP_FORM_SUBMIT = 'EDIT_CUSTOM_FIELD_GROUP_FORM_SUBMIT'
export const EDIT_CUSTOM_FIELD_GROUP_FORM_SUCCESS = 'EDIT_CUSTOM_FIELD_GROUP_FORM_SUCCESS'

export const EDIT_CUSTOM_FIELD_LABEL_FORM_FAILURE = 'EDIT_CUSTOM_FIELD_LABEL_FORM_FAILURE'
export const EDIT_CUSTOM_FIELD_LABEL_FORM_SUBMIT = 'EDIT_CUSTOM_FIELD_LABEL_FORM_SUBMIT'
export const EDIT_CUSTOM_FIELD_LABEL_FORM_SUCCESS = 'EDIT_CUSTOM_FIELD_LABEL_FORM_SUCCESS'

export const MARK_CUSTOM_FIELD_LABEL_DROPDOWN_ENTRY_AS_NOT_NEW = 'MARK_CUSTOM_FIELD_LABEL_DROPDOWN_ENTRY_AS_NOT_NEW'
export const MARK_CUSTOM_FIELD_LABEL_DROPDOWN_ENTRY_FOR_DELETION = 'MARK_CUSTOM_FIELD_LABEL_DROPDOWN_ENTRY_FOR_DELETION'
export const MOVE_CUSTOM_FIELD_LABEL_DROPDOWN_ENTRY = 'MOVE_CUSTOM_FIELD_LABEL_DROPDOWN_ENTRY'
export const SORT_CUSTOM_FIELD_LABEL_DROPDOWN_ENTRIES = 'SORT_CUSTOM_FIELD_LABEL_DROPDOWN_ENTRIES'

export const MOVE_CUSTOM_FIELD_LABEL_CUSTOM_FIELD_GROUP = 'MOVE_CUSTOM_FIELD_LABEL_CUSTOM_FIELD_GROUP'

export const NEW_CUSTOM_FIELD_GROUP_FORM_FAILURE = 'NEW_CUSTOM_FIELD_GROUP_FORM_FAILURE'
export const NEW_CUSTOM_FIELD_GROUP_FORM_SUBMIT = 'NEW_CUSTOM_FIELD_GROUP_FORM_SUBMIT'
export const NEW_CUSTOM_FIELD_GROUP_FORM_SUCCESS = 'NEW_CUSTOM_FIELD_GROUP_FORM_SUCCESS'

export const NEW_CUSTOM_FIELD_LABEL_FORM_FAILURE = 'NEW_CUSTOM_FIELD_LABEL_FORM_FAILURE'
export const NEW_CUSTOM_FIELD_LABEL_FORM_SUBMIT = 'NEW_CUSTOM_FIELD_LABEL_FORM_SUBMIT'
export const NEW_CUSTOM_FIELD_LABEL_FORM_SUCCESS = 'NEW_CUSTOM_FIELD_LABEL_FORM_SUCCESS'

export const REPOSITION_CUSTOM_FIELD_LABEL = 'REPOSITION_CUSTOM_FIELD_LABEL'
export const REPOSITION_CUSTOM_FIELD_LABEL_FAILURE = 'REPOSITION_CUSTOM_FIELD_LABEL_FAILURE'
export const REPOSITION_CUSTOM_FIELD_LABEL_SUCCESS = 'REPOSITION_CUSTOM_FIELD_LABEL_SUCCESS'

export const SORT_CUSTOM_FIELD_LABELS = 'SORT_CUSTOM_FIELD_LABELS'
export const SORT_CUSTOM_FIELD_LABELS_SUCCESS = 'SORT_CUSTOM_FIELD_LABELS_SUCCESS'
export const SORT_CUSTOM_FIELD_LABELS_FAILURE = 'SORT_CUSTOM_FIELD_LABELS_FAILURE'

export const UPDATE_CUSTOM_FIELD_LABEL = 'UPDATE_CUSTOM_FIELD_LABEL'
export const UPDATE_CUSTOM_FIELD_LABEL_SUCCESS = 'UPDATE_CUSTOM_FIELD_LABEL_SUCCESS'
export const UPDATE_CUSTOM_FIELD_LABEL_FAILURE = 'UPDATE_CUSTOM_FIELD_LABEL_FAILURE'
